export default __webpack_public_path__ + "2c5c753.png";